import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from 'vuetify/src/locale/pt.ts'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        success: '#006400', // Dark green
      },
      dark: {
        success: '#006400', // Dark green
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
});